import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { Observable } from 'rxjs'
import { ValidationErrorHintDirective } from '../../directives'
import { RadioItem } from './radio-item'
import { RadioComponent } from './radio.component'

let nextId = 0

/**
 * Styles a radio list can be displayed in
 */
export enum RadioListStyle {
  /**
   * One radio button per line
   */
  Multiline = 'multiline',
  /**
   * Radio buttons are inlined where possible
   */
  Inline = 'inline',
  /**
   * One radio button per line, lines are close together
   */
  MultilineCompact = 'multiline-compact',
}

/**
 * A radio button list
 *
 * @see RadioComponent
 */
@Component({
  selector: 'ftr-radio-list',
  templateUrl: './radio-list.component.html',
  styleUrls: ['./radio-list.component.css'],
  standalone: true,
  imports: [CommonModule, RadioComponent, ValidationErrorHintDirective],
})
export class RadioListComponent<TEnum> {
  /**
   * List of radio items to display to the user
   */
  @Input() items: Observable<RadioItem<TEnum>[]>

  /**
   * Label to show on validation errors
   */
  @Input() validationLabel: string

  /**
   * The control that drives this field, used to display validation
   */
  @Input() control: UntypedFormControl
  /**
   * Style to display the radio list in
   *
   * @see RadioListStyle
   */
  @Input() style: RadioListStyle = RadioListStyle.Inline
  /**
   * Whether submission of the form this component is part of has been attempted. When submission is attempted, the
   * underlying validation control (i.e.: ValidationHint) may choose to display validation states for fields which have
   * not yet been touched.
   */
  @Input() submitAttempted = false

  readonly name = `ftr-radio-list-${nextId++}`
}
